module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "form-control text-center",
    attrs: {
      "type": "text",
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.inimsg
    },
    on: {
      "blur": _vm.Blur,
      "focus": _vm.Focus
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b98b0f6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UserCheckInput.vue
// module id = 1480
// module chunks = 0